import Vue from 'vue'

const STORAGE_KEY = 'otc.appendMode'

function load() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

function persist(state) {
  try {
    if (state.isActive) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        isActive: state.isActive,
        transactionId: state.transactionId,
        orderNumber: state.orderNumber,
        customerName: state.customerName,
        balanceDue: state.balanceDue
      }))
    } else {
      sessionStorage.removeItem(STORAGE_KEY)
    }
  } catch (e) {
    // sessionStorage disabled (private mode, etc.) — non-fatal
  }
}

const initial = load() || {}

export const appendModeState = Vue.observable({
  isActive: initial.isActive || false,
  transactionId: initial.transactionId || null,
  orderNumber: initial.orderNumber || null,
  customerName: initial.customerName || null,
  balanceDue: initial.balanceDue || 0
})

export function enterAppendMode({ transactionId, orderNumber, customerName, balanceDue }) {
  appendModeState.isActive = true
  appendModeState.transactionId = transactionId
  appendModeState.orderNumber = orderNumber || null
  appendModeState.customerName = customerName || null
  appendModeState.balanceDue = Number(balanceDue) || 0
  persist(appendModeState)
}

export function exitAppendMode() {
  appendModeState.isActive = false
  appendModeState.transactionId = null
  appendModeState.orderNumber = null
  appendModeState.customerName = null
  appendModeState.balanceDue = 0
  persist(appendModeState)
}

export function updateAppendModeBalance(balanceDue) {
  if (!appendModeState.isActive) return
  appendModeState.balanceDue = Number(balanceDue) || 0
  persist(appendModeState)
}

// Returns true when the given slot can be clicked during append mode.
// Calendar / list / kanban / resource surfaces call this
// before opening the drawer so booked or completed private slots don't enter
// the append flow (they can't accept another booking). Public slots are the
// exception — clicking them in append mode adds a new child group under the
// master, which add-booking-to-transaction's handlePublicBookingSlot covers.
//
// `slot` may be either a raw row (transaction_id / status at the top level)
// or a card object that wraps the row in `originalData`. We check both so
// callers don't need to know which shape they have. Field naming for public
// also differs by surface (is_public_booking vs is_public) — both checked.
// When append mode is OFF this always returns true.
export function canAppendToSlot(slot) {
  if (!appendModeState.isActive) return true
  if (!slot) return true
  const row = slot.originalData || slot
  const isPublic = !!(row.is_public_booking || row.is_public)
  if (isPublic) return true
  const slotIsTaken = !!row.transaction_id || row.status === 'completed'
  return !slotIsTaken
}
